export default {
  wrapper: {
    m: 'auto',
    gap: 3,
  },
  iconWrapper: {
    display: 'inline-flex',
    flexShrink: 0,
  },
};
